<template>
  <a-card>
    <a-row>
      <a-col :span="5">
        <a-form-item label="平台" :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-select v-model:value="platValue" show-search placeholder="请选择" :options="platType"
                    @change="selectChange">
          </a-select>
        </a-form-item>
      </a-col>
      <a-col :span="5">
        <a-form-item label="课程" :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-select v-model:value="courseValue" show-search placeholder="请选择" :options="courses"
                    @change="onFilterChange">
          </a-select>
        </a-form-item>
      </a-col>
      <a-col :span="3">
        <a-form-item label="类型" :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-select v-model:value="typeValue" show-search placeholder="请选择" :options="typeList"
                    @change="onFilterChange">
          </a-select>
        </a-form-item>
      </a-col>
      <a-col :span="5">
        <a-form-item label="问题" :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-input v-model:value="searchValue.question" placeholder="搜索问题"/>
        </a-form-item>
      </a-col>

      <a-col :span="3">
        <a-form-item label="无答案" :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-checkbox v-model:checked="searchValue.onlyShowEmptyAnswer"></a-checkbox>
        </a-form-item>

      </a-col>

      <a-col :span="2">
        <a-form-item :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-button type="primary" @click="onSearch" @keyup.enter="onSearch">
            <SearchOutlined/>
            搜索
          </a-button>
        </a-form-item>
      </a-col>
    </a-row>
  </a-card>

  <a-layout>
    <a-layout-content>
      <div style="padding-top: 24px; text-align: center;">
        <a-card :bordered="false" style="width: 100%; text-align: start;" :bodyStyle="style">
          <template #extra>
            <div class="extra-actions">
              <div class="manage-toggle" v-if="canManageQuestions">
                <span>管理模式</span>
                <a-switch v-model:checked="manageMode" size="small" @change="onManageToggle" />
              </div>
              <a-select
                v-if="canManageQuestions && manageMode"
                v-model:value="scopeValue"
                :options="scopeOptions"
                @change="onScopeChange"
                style="width: 160px"
              />
              <a-button
                v-if="canManageQuestions && manageMode"
                type="primary"
                size="small"
                :disabled="!selectedRowKeys.length"
                @click="makeSelectedPublic"
              >
                批量设为公共
              </a-button>
              <a-button
                v-if="canManageQuestions && manageMode"
                type="primary"
                danger
                size="small"
                :disabled="!selectedRowKeys.length"
                @click="makeSelectedPrivate"
              >
                批量设为私有
              </a-button>
            </div>
            <a-button type="primary" @click="navigateToImport" style="margin-right: 12px;">
              <DownloadOutlined/>
              智能导入
            </a-button>
            <a-button v-if="canWriteQuestions" type="primary" @click="showModal({
              type: 0,
              question: '',
              options: '[]',
              answer: '[]'
            }, 2)">
              <FormOutlined/>
              添加
            </a-button>
          </template>
          <a-alert v-if="activeNotebookId" type="info" show-icon class="record-alert">
            <template #message>
              正在将搜索结果记录到笔记本：{{ activeNotebookName || activeNotebookId }}
            </template>
            <template #action>
              <a-button size="small" :loading="recordingSyncing" @click="stopRecordingNotebook">停止</a-button>
            </template>
          </a-alert>
          <a-table
            :columns="columns"
            :data-source="data"
            :pagination="false"
            :row-key="record => record.id"
            :loading="tabLoading"
            :scroll="{ x: 1300 }"
            :row-selection="canManageQuestions && manageMode ? rowSelection : null"
          >
            <template #type="{ record }">
              <a-tag :color="record.type === 0 ? 'green' : record.type === 1 ? 'cyan' : 'orange'">
                {{ quesType[record.type] }}
              </a-tag>
            </template>
            <template #public="{ record }">
              <a-tag :color="record.is_public ? 'green' : 'volcano'">
                {{ record.is_public ? '公共' : '私有' }}
              </a-tag>
            </template>
            <template #answer="{ record }">
              <div class="answer-tags">
                <a-tag v-for="(value, index) in safeParseJson(record.answer)" color="blue" :key="index">
                  <span class="tag-content" :title="String(record.source === 2 ? index : value)">
                    {{ String(record.source === 2 ? index : value) }}
                  </span>
                </a-tag>
              </div>
            </template>




            <template #action="{ record }">
              <div class="action-group">
                <a-button v-if="canWriteQuestions" size="small" type="primary" ghost @click="showModal(record, 1)">编辑</a-button>
                <a-button
                  v-if="canManageQuestions && !record.is_public && manageMode"
                  size="small"
                  type="primary"
                  class="public-btn"
                  @click="makePublic(record)"
                >加入公共</a-button>
                <a-button
                  v-if="canManageQuestions && record.is_public && manageMode"
                  size="small"
                  danger
                  ghost
                  @click="makePrivate(record)"
                >设为私有</a-button>
                <a-button v-if="canWriteQuestions" size="small" type="primary" ghost danger @click="deleteQuestion(record.id)">删除</a-button>
              </div>
            </template>
          </a-table>
          <a-pagination @change="onChange" :current="page.pageNo" :total="page.total" show-size-changer
                        :page-size-options="page.pageSizeOptions" :page-size="page.pageSize"
                        @showSizeChange="onShowSizeChange"
                        style="margin-top: 20px; text-align: right;"/>
        </a-card>

      </div>
      <a-modal :visible="visible" title="详情内容" @ok="confirm" @cancel="visible = false" v-if="visible">
        <a-form :model="formData">
          <a-form-item label="类型">
            <a-select v-model:value="formData.type">
              <a-select-option v-for="(value, key) in quesType" :key="key" :value="parseInt(key)">
                {{ value }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item v-if="canManageQuestions" label="可见性">
            <a-radio-group v-model:value="formData.is_public">
              <a-radio :value="true">公共</a-radio>
              <a-radio :value="false">私有</a-radio>
            </a-radio-group>
            <div class="visibility-hint">公共：全局可见；私有：仅当前操作者自己使用</div>
          </a-form-item>
          <a-form-item label="问题" class="margin_top">
            <a-textarea v-model:value="formData.question"/>
          </a-form-item>
          <div v-if="/[013]/.test(formData.type)" class="margin_top">
            <a-form-item label="选项">
              <OptionBox :options="safeParseJson(formData.options)" :type="formData.type"
                         :answer="answer" ref="optionBox"/>
            </a-form-item>
          </div>
          <div v-else>
            <a-card :bordered="false" style="width: 100%; text-align: start;" :bodyStyle="style">
              <a-tabs default-active-key="1">
                <a-tab-pane tab="默认选项" key="1">
                  <AnswerBox :answer="answer" ref="answerBox"/>
                </a-tab-pane>
                <a-tab-pane tab="提交附件" key="2">
                  <div>
                  <a-upload-dragger name="file" multiple="true" show-upload-list="true"
                                      :headers="uploadHeaders"
                                      action='/api/tiku/v1/upload?parentDir=myword' @change="handleChange">
                      <p class="ant-upload-drag-icon">
                        <upload-outlined></upload-outlined>
                      </p>
                      <p class="ant-upload-text">点击或者拖动文件到该区域来上传</p>
                      <p class="ant-upload-hint">请不要上传敏感数据，银行卡号和密码，信用卡号有效期和安全码</p>
                    </a-upload-dragger>
                  </div>

                </a-tab-pane>
              </a-tabs>


            </a-card>
          </div>
        </a-form>
      </a-modal>
    </a-layout-content>
  </a-layout>
</template>

<script>
import {defineComponent, ref, computed} from 'vue';
import {useRouter} from 'vue-router';
import {
  getPlat,
  getCourses,
  getQuestions,
  updateQuestions,
  delQuestions,
  createQuestions,
  stopNotebook
} from '@/api/TikuComponentApi'
import {
  FormOutlined,
  DownloadOutlined,
  SearchOutlined,
  UploadOutlined
} from '@ant-design/icons-vue';
import OptionBox from '../../components/OptionBox/index.vue'
import AnswerBox from '../../components/AnswerBox/index.vue'
import {questionType} from "@/utils/uitls";
import {message} from "ant-design-vue";
import { hasGlobalAccess, hasPermission, PERMISSIONS } from '@/utils/permissions'
import { asPageResult } from '@/utils/result'

const style = {
  padding: "0 0 24px"
}
const fileList = ref([])
const tabLoading = ref(true)
const data = ref([])
const ACTIVE_NOTEBOOK_ID_KEY = 'adapterActiveNotebookId'
const ACTIVE_NOTEBOOK_NAME_KEY = 'adapterActiveNotebookName'
const activeNotebookId = ref(localStorage.getItem(ACTIVE_NOTEBOOK_ID_KEY) || '')
const activeNotebookName = ref(localStorage.getItem(ACTIVE_NOTEBOOK_NAME_KEY) || '')
const recordingSyncing = ref(false)
const manageMode = ref(false)
const selectedRowKeys = ref([])
const rowSelection = computed(() => ({
  selectedRowKeys: selectedRowKeys.value,
  onChange: keys => { selectedRowKeys.value = keys }
}))
const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 80,
    fixed: 'left'
  },
  {
    title: '类型',
    key: 'type',
    dataIndex: 'type',
    width: 100,
    slots: {
      customRender: 'type',
    },
  },
  {
    title: '课程名称',
    width: 150,
    dataIndex: 'course_name',
    key: 'course_name',
    ellipsis: true,
  },
  {
    title: '问题',
    dataIndex: 'question',
    key: 'question',
    ellipsis: true,
    width: 300,
  },
  {
    title: '答案',
    dataIndex: 'answer',
    key: 'answer',
    width: 250,
    slots: {
      customRender: 'answer',
    },
  },
  {
    title: '拓展参数',
    dataIndex: 'extra',
    key: 'extra',
    width: 150,
    ellipsis: true,
  },
  {
    title: '来源',
    dataIndex: 'origin',
    key: 'origin',
    width: 120,
    ellipsis: true,
  },
  {
    title: '归属用户',
    dataIndex: 'owner_id',
    key: 'owner_id',
    width: 100,
  },
  {
    title: '可见性',
    dataIndex: 'is_public',
    key: 'is_public',
    width: 100,
    slots: { customRender: 'public' },
  },
  {
    title: '操作',
    fixed: 'right',
    key: 'action',
    width: 220,
    slots: {
      customRender: 'action',
    },
  },
]
const page = ref({
  pageSizeOptions: ['10', '20', '50', '100'],
  pageNo: 1,
  pageSize: 10,
  total: 0
})

const typeValue = ref(null)
const typeList = ref([])
const platType = ref([])
const courses = ref([])
const courseValue = ref(null)
const platValue = ref(null)
const formData = ref({})
const answer = ref([])
const visible = ref(false)
const action = ref(2) // 1是编辑 2是添加
const searchValue = ref({})
const quesType = ref(questionType)
const scopeValue = ref('public')
const scopeOptions = [
  { label: '公共', value: 'public' },
  { label: '用户私有', value: 'user-private' },
  { label: '全部', value: 'all' },
  { label: '仅自己', value: 'self' },
]
const uploadHeaders = computed(() => ({}))
export default defineComponent({
  name: 'TikuComponent',
  setup() {
    const router = useRouter();
    const canReadQuestions = computed(() => hasPermission(PERMISSIONS.QUESTION_READ))
    const canWriteQuestions = computed(() => hasPermission(PERMISSIONS.QUESTION_WRITE))
    const canManageQuestions = computed(() => hasGlobalAccess())
    const navigateToImport = () => {
      router.push('/adapter/import');
    };
    const safeParseJson = (jsonStr) => {
      try {
        if (!jsonStr) return []
        return JSON.parse(jsonStr)
      } catch (e) {
        return []
      }
    }
    return {
      safeParseJson,
      tabLoading,
      typeList,
      typeValue,
      courses,
      platType,
      courseValue,
      platValue,
      answer,
      page,
      data,
      columns,
      quesType,
      visible,
      formData,
      style,
      searchValue,
      scopeOptions,
      scopeValue,
      canReadQuestions,
      canWriteQuestions,
      canManageQuestions,
      uploadHeaders,
      labelCol: {span: 8},
      wrapperCol: {span: 14},
      navigateToImport,
      fileList,
      activeNotebookId,
      activeNotebookName,
      recordingSyncing,
      manageMode,
      selectedRowKeys,
      rowSelection
    }
  },
  components: {
    UploadOutlined,
    OptionBox,
    AnswerBox,
    FormOutlined,
    SearchOutlined,
    DownloadOutlined
  },
  mounted() {
    if (!this.canReadQuestions) {
      message.error('无权限访问题库')
      this.$router.push('/adapter/user-dashboard')
      return
    }
    this.getType()
    this.getCourses()
    this.getPlat()
    scopeValue.value = this.canManageQuestions ? 'self' : scopeValue.value
    this.fetchData()
  },
  methods: {
    onManageToggle() {
      if (!manageMode.value) {
        scopeValue.value = 'self'
      } else if (scopeValue.value === 'self') {
        scopeValue.value = 'public'
      }
      selectedRowKeys.value = []
      this.fetchData()
    },
    persistNotebookState(id, name) {
      activeNotebookId.value = id || ''
      activeNotebookName.value = name || ''
      if (id) {
        localStorage.setItem(ACTIVE_NOTEBOOK_ID_KEY, id)
        localStorage.setItem(ACTIVE_NOTEBOOK_NAME_KEY, name || '')
      } else {
        localStorage.removeItem(ACTIVE_NOTEBOOK_ID_KEY)
        localStorage.removeItem(ACTIVE_NOTEBOOK_NAME_KEY)
      }
    },
    async stopRecordingNotebook() {
      if (!activeNotebookId.value) return
      try {
        await stopNotebook(activeNotebookId.value)
        message.success('已停止记录')
      } catch (e) {
        console.warn(e)
      } finally {
        this.persistNotebookState('', '')
      }
    },
    async selectChange(info) {
      const list = await getCourses({plat: info})
      if (list?.data && list?.data.length) {
        await this.getCourses(list?.data)
      } else {
        courses.value = []
      }
      // Reset page number when platform changes and fetch data
      this.page.pageNo = 1
      await this.fetchData()
    },
    async onFilterChange() {
      // Reset page number when any filter changes and fetch data
      this.page.pageNo = 1
      await this.fetchData()
    },
    handleChange(info) {
      const status = info.file.status;
      if (status === 'done') {
        message.success('?????');
        fileList.value.push(info.file.response)
        this.$refs.answerBox.pushAnswer(info.file.response)
      } else if (status === 'error') {
        // 处理上传失败
        message.error(`${info.file.name} 上传失败`);
      }
    },
    typeObjects(types) {
      return Object.entries(types).map(([key, value]) => ({
        value: parseInt(key),
        label: value
      }));
    },
    getType() {
      const arr = this.typeObjects(questionType)
      typeList.value = arr
    },
    async getCourses(data) {
      if (data) {
        courses.value = data.map(i => {
          return {
            value: i,
            label: i,
          }
        })
      } else {
        const list = await getCourses()

        if (list?.data && list?.data.length) {
          courses.value = list?.data.map(i => {
            return {
              value: i,
              label: i,
            }
          })
        }
      }
    },

     getPlatStr(plat){
      for (let valueElement of platType.value) {
        if (plat === valueElement.value){
          return valueElement.label
        }
      }
    },
    async getPlat() {
      const list = await getPlat()
      if (list?.data && list?.data.length) {
        platType.value = list?.data.map(i => {
          return {
            value: parseInt(i.Value),
            label: i.Label,
          }
        })
      }
    },
    async fetchData() {
      fileList.value = []
      tabLoading.value = true
      selectedRowKeys.value = []
      const payload = {
        courseName: courseValue.value ? courseValue.value : "",
        plat: !isNaN(parseInt(platValue.value)) ? parseInt(platValue.value) : -1,
        type: !isNaN(parseInt(typeValue.value)) ? parseInt(typeValue.value) : -1,
        pageSize: page.value.pageSize,
        pageNo: page.value.pageNo - 1,
        question: searchValue.value.question || '',
        source: parseInt(searchValue.value.source) || 0,
        extra: searchValue.value.extra || '',
        onlyShowEmptyAnswer: searchValue.value.onlyShowEmptyAnswer || false
      }
      const params = {}
      if (this.canManageQuestions) {
        if (manageMode.value && scopeValue.value) {
          params.scope = scopeValue.value
        } else if (!manageMode.value) {
          params.scope = 'self'
        }
      }
      if (!this.canManageQuestions && scopeValue.value === 'self') {
        params.scope = scopeValue.value
      }
      try {
        const res = await getQuestions(payload, params)
        const pageResult = asPageResult(res?.data, page.value.pageSize)
        data.value = pageResult.data
        this.page.total = pageResult.total
      } finally {
        tabLoading.value = false
      }
    },
    onSearch() {
      // Reset page number when search filters change
      this.page.pageNo = 1
      this.fetchData()
    },
    onScopeChange() {
      this.page.pageNo = 1
      this.fetchData()
    },
    onShowSizeChange(current, pageSize) {
      this.page.pageSize = pageSize
      this.page.pageNo = 1
      this.fetchData()
    },

    onChange(page) {
      this.page.pageNo = page
      this.fetchData()
    },

    showModal(record, act) {
      if (record.options === '[]' || record.options === '') {
        record.options = '[]'
      }
      if (record.answer === '[]' || record.answer === '') {
        record.answer = '[]'
      }

      const normalized = { ...record }
      if (normalized.is_public === undefined || normalized.is_public === null) {
        normalized.is_public = this.canManageQuestions ? true : false
      } else {
        normalized.is_public = !!normalized.is_public
      }
      formData.value = normalized
      answer.value = formData.value.answer ? JSON.parse(formData.value.answer) : []
      action.value = act
      fileList.value = []
      visible.value = true
    },

    async deleteQuestion(id) {
      fileList.value = []
      await delQuestions({id: id}).then(res => {
        res.status == 200 ? message.success('?????') : message.error(`删除失败`)
      })
      visible.value = false
      await this.fetchData()
    },

    async makePublic(record) {
      const payload = {
        id: record.id,
        is_public: true,
        owner_id: 0,
        origin: record.origin || 'user-upload',
      }
      const res = await updateQuestions(payload)
      if (res.status === 200) {
        message.success('操作成功')
      } else {
        message.error('操作失败')
      }
      await this.fetchData()
    },
    async makePrivate(record) {
      const payload = {
        id: record.id,
        is_public: false,
        owner_id: record.owner_id || 0,
      }
      const res = await updateQuestions(payload)
      if (res.status === 200) {
        message.success('已设为私有')
      } else {
        message.error('操作失败')
      }
      await this.fetchData()
    },
    async makeSelectedPublic() {
      if (!selectedRowKeys.value.length) return
      const tasks = selectedRowKeys.value.map(id => updateQuestions({
        id,
        is_public: true,
        owner_id: 0,
      }))
      try {
        const results = await Promise.all(tasks)
        const ok = results.filter(r => r?.status === 200).length
        if (ok) {
          message.success(`已处理 ${ok} 条`)
        } else {
          message.error('操作失败')
        }
      } finally {
        selectedRowKeys.value = []
        this.fetchData()
      }
    },
    async makeSelectedPrivate() {
      if (!selectedRowKeys.value.length) return
      const tasks = selectedRowKeys.value.map(id => updateQuestions({
        id,
        is_public: false,
      }))
      try {
        const results = await Promise.all(tasks)
        const ok = results.filter(r => r?.status === 200).length
        if (ok) {
          message.success(`已设为私有 ${ok} 条`)
        } else {
          message.error('操作失败')
        }
      } finally {
        selectedRowKeys.value = []
        this.fetchData()
      }
    },


    async confirm() {
      formData.value.type = parseInt(formData.value.type)
      formData.value.is_public = !!formData.value.is_public

      if (/[0|1|3]/.test(formData.value.type)) {
        const childComponentData = this.$refs.optionBox.getData()
        Object.assign(formData.value, childComponentData)
      } else {
        const textAns = this.$refs.answerBox.getData()
        console.log('textAns==>', textAns)
        formData.value.answer = textAns
      }
      let response;
      const successMessage = action.value === 1 ? '修改成功' : '创建成功';
      const errorMessage = action.value === 1 ? '修改失败' : '创建失败';
      if (action.value === 1) {
        response = await updateQuestions(formData.value)
      } else if (action.value === 2) {
        response = await createQuestions([formData.value])
      }
      if (response.status === 200) {
        message.success(successMessage);
      } else {
        message.error(errorMessage);
      }
      fileList.value = []
      visible.value = false
      await this.fetchData()
    },
  }
})
</script>
<style scoped>
header {
  width: 100%;
  height: 60px;
  background-color: #195ca3;
  border-bottom: 1px solid #e8e8e8;
  line-height: 60px;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  color: #fff;
}

.ant-form-item {
  margin-bottom: 0;
}

.margin_top {
  margin-top: 5%
}

.record-alert {
  margin-bottom: 12px;
}

.visibility-hint {
  margin-top: 4px;
  color: #8c8c8c;
  font-size: 12px;
}

.extra-actions {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-right: 12px;
  flex-wrap: wrap;
}

.manage-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #555;
}

.action-group {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.public-btn {
  background: linear-gradient(90deg, #1677ff, #4096ff);
  border: none;
  color: #fff;
}

.answer-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  max-height: 66px;
  overflow: hidden;
}

.tag-content {
  display: inline-block;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
}
</style>
